import { Pipe, PipeTransform } from '@angular/core';
import { formatInvoiceNumber } from '@wilson/utils';

@Pipe({
  name: 'invoiceNumberFormat',
  standalone: false,
})
export class InvoiceNumberPipe implements PipeTransform {
  transform(
    nextInvoiceNumber: number | null | undefined,
    invoiceNumberNumberOfDigits: number | null | undefined,
    invoiceNumberCustomPrefix?: string | null,
  ): string {
    return formatInvoiceNumber(
      nextInvoiceNumber,
      invoiceNumberNumberOfDigits,
      invoiceNumberCustomPrefix,
    );
  }
}
